import { request } from '../request'
import type { AxiosResponse } from 'axios'
import { Dayjs } from 'dayjs'
import { AlertFOCItemDTO } from '@models/api/AlertFOCItemDTO'
import { TDateISODateFormat } from '@services/DateService'
import { AlertFOCUpdateItemDTO } from '@models/api/AlertFOCUpdateItemDTO'
import { AlertFOCUpdateResponseItemDTO } from '@models/api/AlertFOCUpdateResponseItemDTO'

export const focAlerts = {
  getFocAlerts: function (
    date?: Dayjs
  ): Promise<AxiosResponse<AlertFOCItemDTO[]>> {
    return request.get('alerta-foc/latest', {
      params: {
        date: date?.format(TDateISODateFormat)
      }
    })
  },

  isPublished: function (date?: Dayjs): Promise<AxiosResponse<boolean>> {
    return request.get('alerta-foc/isPublished', {
      params: {
        date: date?.format(TDateISODateFormat)
      }
    })
  },

  updateFocAlerts: function (
    focAlerts: AlertFOCUpdateItemDTO[]
  ): Promise<AxiosResponse<AlertFOCUpdateResponseItemDTO[]>> {
    return request.post('alerta-foc/updateAlertas', focAlerts)
  },

  publish: function (date?: Dayjs): Promise<AxiosResponse<any>> {
    return request.post('alerta-foc/publish', {
      date: date?.format(TDateISODateFormat)
    })
  },

  existReport: function (date?: Dayjs): Promise<AxiosResponse<boolean>> {
    return request.get('alerta-foc/existReport', {
      params: {
        date: date?.format(TDateISODateFormat)
      }
    })
  }
}
